import React from 'react';

const About = () => (
  <div>
    <h1>About Us</h1>
    <p>We are a family-run agriculture business dedicated to providing fresh and organic produce.</p>
  </div>
);

export default About;
